export const clone_page_atom_service_to_theme_atom_service = {
  error_unknown: 'Có lỗi trong hệ thống',
  clone_error: 'Clone lỗi',
  clone_success: 'Clone thành công',
  cloning: 'Cloning',
  init_clone: 'Đang khởi tạo quá trình',
  init_clone_error: 'Quá trình khởi tạo bị lỗi',
} as const;
